import React, { useMemo, useState, useEffect } from 'react';
import { Button, Cell, Grid, CardTitle, SelectField, SelectionControlGroup } from 'react-md';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import SecureShow from '../component/SecureShow';
import MultiSelectReact from 'react-multi-select-ext'
import insertNewLine from 'draft-js-focus-plugin/lib/modifiers/insertNewLine';
import { AppProperties } from '../common/function';
import 'react-notifications/lib/notifications.css';

//resource_link_title
const selectedOptionsStyles = {
    color: '#FFFFFF',
    backgroundColor: '#bb0000'
};
const optionsListStyles = {
    backgroundColor: '#FFFFFF',
    color: '#bb0000'
};

let globalVarCourses = [];
const LTIQuizPage = ({location})=>{
    const {query} = location;
    const {ltiQuizID,ltiSectionID,resourceLinkTitle,ltiUserID,token} = query;
    const appProperties = AppProperties();
    const [courses,setCourses] = useState(null)
    const [sections,setSections] =  useState([]);
    const [quizes,setQuizes] =  useState([]);
    const [loading,setLoading] =  useState(false);
    const [coursesLoading,setCoursesLoading] =  useState(false);
    const [quizLoading,setQuizLoading] =  useState(false);
    const [quizLink,setQuizLink] =  useState(false);
    const [showSectionSelect,setShowSectionSelect] = useState(false);
    const [showQuizSelect,setShowQuizSelect] = useState(false);
    const [showMapButton,setShowMapButton] = useState(false);
    const [selectedCourse,setSelectedCourse] = useState(null)
    const [selectedSection,setSelectedSection] = useState(null)
    const [isSubsectionEnable,setIsSubsectionEnable] = useState(false)
    const [selectedQuiz,setSelectedQuiz] = useState(null);
    const [DBSnapShotQuizArr, setDBSnapShotQuizArr] = useState([])
    const [selectedRadio, setSelectedRadio] = useState("assignment")
    const [isPracticeMapped, setIsPracticeMapped] = useState(false);

    useEffect(() => {
        console.debug("token", token, appProperties.currentUserData)
        if (token) {
            const [encodedHeader, encodedPayload, signature] = token.split('.');
            let decodedPayload;
            try {
                decodedPayload = JSON.parse(atob(encodedPayload));    
            } catch (error) {
                console.debug("error while decoding token", error, token)
            }
            
            appProperties.currentUserData.setUserDetails(decodedPayload,appProperties.loginType);

            const queryParams = new URLSearchParams(window.location.search);

            // Remove the token once it's been used
            if (queryParams.has('token')) {
                queryParams.delete('token');
                const newSearch = queryParams.toString();
                const newPath = `${window.location.pathname}?${newSearch}`;

                const encodedPath = encodeURI(newPath);

                console.debug("encodedPath", encodedPath)

                window.history.replaceState(null, '', encodedPath);
                window.location.reload();
            }
        }
        
        getLTIQuizMap();

    }, [])

    //API Calls
    const getLTIQuizMap = () => {
        setLoading(true);
        const payload = {
            lti_quiz_id: ltiQuizID,
            lti_section_id: ltiSectionID
        };
        ApiRequestService({
            method: 'post',
            url: appProperties.enableLTI ? '/getLTIQuizMap' : '/getLTI13QuizMap',
            data: payload
          }).then(res => {
            if(res.data){
                if(res.data.status !== 0){
                    if(res.data.message){
                        if(res.data.message !== 'sql: no rows in result set')
                            NotificationManager.error(res.data.message, 'Error Message', 5000);
                        else{
                            //getAllSections();
                            getAllCourses();
                        }
                    }
                    else
                        NotificationManager.error("Error when getting sections", 'Error Message', 5000);
                }else{
                    if(res.data.data){
                        if (res.data.data?.for_practice) {
                            setSelectedRadio("practice")
                            setIsPracticeMapped(true);
                        }
                        const {lti_quiz_Link,section_name,section_id,course_id,quiz_id,quiz_name, enable_subsection} = res.data.data;
                        setSelectedCourse({course_id})
                        setSelectedSection({section_name,course_id,section_id});
                        setIsSubsectionEnable(enable_subsection)
                        if(!enable_subsection){setSelectedQuiz({'id':quiz_id,'label':quiz_name});}
                        setDBSnapShotQuizArr(quiz_id)
                        getAllCourses().finally(()=>{
                        let isCoursePresent = globalVarCourses.some((dataRes)=> dataRes.course_id == course_id)
                        if(isCoursePresent){
                            setSelectedCourse({course_id})
                            getAllSections({course_id})
                            getAllQuizes({section_id,course_id},quiz_id)
                            setShowQuizSelect(true);
                            setShowMapButton(true);
                            setQuizLink(lti_quiz_Link);
                        }else{
                            setSelectedCourse({course_id:0})
                        } 
                        })
                    }
                }
            }
          }).catch(err=>{
            NotificationManager.error(err, 'Error Message', 5000);
          }).finally(()=>{
            setLoading(false);
          });
    }

const getAllCourses = () => {
    setLoading(true);
    setShowQuizSelect(false);
    setCoursesLoading(true)
    return new Promise((res, reject) => {
        ApiRequestService({
            method: 'post',
            url: '/getAllCourses'
        }).then(res =>{
            if(res.data){
                if(res.data.status !== 0){
                    if(res.data.message)
                        NotificationManager.error(res.data.message, 'Error Message', 5000);
                    else
                        NotificationManager.error("Error when getting sections", 'Error Message', 5000);
                }else{
                    if(res.data.data){
                        let course = res.data.data.course_names?.map(course => {return {'label': course.course_name, 'course_id': course.course_id,"is_lti_enabled":course.is_lti_enabled }})
                        if (course && course.length) {
                            let ltiCourse = course.filter(course => course.is_lti_enabled)
                            globalVarCourses = ltiCourse
                            setCourses(ltiCourse);
                        } else {
                            setCourses([]);
                        }   
                    }
                }
            }
        }).catch(err=>{
            NotificationManager.error(err, 'Error Message', 5000);
          }).finally(()=>{
            setLoading(false);
            setCoursesLoading(false)
            res();
          });
    })
}
    const getAllSections = (course) => {
        setLoading(true);
        setShowQuizSelect(false);
       let payload ={
        course_id: course.course_id
       }
       return new Promise((res,reject)=>{
        ApiRequestService({
            method: 'post',
            url: '/getAllSections',
            data: payload
          }).then(res => {
            if(res.data){
                if(res.data.status !== 0){
                    if(res.data.message)
                        NotificationManager.error(res.data.message, 'Error Message', 5000);
                    else
                        NotificationManager.error("Error when getting sections", 'Error Message', 5000);
                }else{
                    if(res.data.data){
                        setSections(res.data.data.section_names.map(section=>{return {'label':section.section_name, 'section_id':section.section_id, 'enable_subsection':section.enable_subsection, enable_practice_and_performance: section.enable_practice_and_performance  }}));
                        setShowSectionSelect(true)
                    }
                }
            }
          }).catch(err=>{
            NotificationManager.error(err, 'Error Message', 5000);
          }).finally(()=>{
            setLoading(false);
            res();
          });
       });
    }

    const getAllQuizes = (section, QuizArr) => {
        setQuizLoading(true);
        setShowQuizSelect(false);
        
        return new Promise((res,reject)=>{
            const payload = {
                course_id: section.course_id,
                section_id: section.section_id
            };
    
            ApiRequestService({
                method: 'post',
                url: '/getAllQuiz',
                data: payload
            }).then(res => {
                if(res.data){
                    if(res.data.status !== 0){
                        if(res.data.message)
                            NotificationManager.error(res.data.message, 'Error Message', 5000);
                        else
                            NotificationManager.error("Error when getting sections", 'Error Message', 5000);
                    }else{
                            if(res.data.data && res.data.data.quizes_list){
                                setQuizes(res.data.data.quizes_list.map(quiz=>{
                                    if(QuizArr && QuizArr.length > 0 && QuizArr.some((id) => id === quiz.quiz_id )){
                                        return {'id':quiz.quiz_id,'label':quiz.quiz_name, 'value': true}
                                    }else{
                                        return {'id':quiz.quiz_id,'label':quiz.quiz_name, 'value': false}
                                    }
                                   
                                }));
                                console.log('log212',res.data.data.quizes_list.length )
                                setShowQuizSelect(true);
                                // For Deleting the quizs 
                                if(res.data.data.quizes_list.length > 0){
                                    setShowMapButton(true)
                                }
                            }else
                            NotificationManager.error("No data returned from server", 'Error Message', 5000);        
                    }
                }
              }).catch(err=>{
                NotificationManager.error(err, 'Error Message', 5000);
               
              }).finally(()=>{
                res();
                    setQuizLoading(false);
               })
        });
    }

    const mapQuiz =(isPractice) => {
        // setLoading(true);

        let insertQuiz = [];
        let deleteQuiz = [];
        
        let tempBackArr = [];
        
        let tempSelectQuiz = []
         quizes.filter((quiz) => {
            if(quiz.value === true){
                tempSelectQuiz.push(quiz.id)
            }
        });

        if(DBSnapShotQuizArr !== null && DBSnapShotQuizArr.length > 0){
             // insert Quiz id
             tempSelectQuiz.filter((id1) => {if(!DBSnapShotQuizArr.some((id2) => id1 === id2 ) ) {insertQuiz.push(id1)} });
             // Delete quiz id
             DBSnapShotQuizArr.filter((id1) => {if(!tempSelectQuiz.some((id2) => id1 === id2 )) {deleteQuiz.push(id1) } });

            let tempDBSnapShotQuizArr = [];
            DBSnapShotQuizArr.filter((id1) => {if(tempSelectQuiz.some((id2) => id1 === id2 )) {tempDBSnapShotQuizArr.push(id1) } });
            tempDBSnapShotQuizArr.push(...insertQuiz);
            
            tempBackArr = tempDBSnapShotQuizArr;
        } else{
            insertQuiz = tempSelectQuiz
            tempBackArr = tempSelectQuiz
        }

        const payload = {
            course_id: selectedCourse.course_id,
            section_id: selectedSection.section_id,
            quiz_id: insertQuiz,
            for_practice: isPractice,
            delete_quiz_id:deleteQuiz,
            lti_quiz_id:ltiQuizID,
            lti_section_id:ltiSectionID,
           // quiz_name:selectedQuiz.quiz_name,
            ltiUserID:ltiUserID,
            lti_assignment_name: decodeURIComponent(resourceLinkTitle)
        };
        
        ApiRequestService({
            method: 'post',
            url: appProperties.enableLTI ? '/mapLtiQuiz' : '/mapLti13Quiz',
            data: payload
        }).then(res => {
            if(res.data){
                if(res.data.status !== 0){
                    if(res.data.message)
                    {
                            NotificationManager.error(res.data.message, 'Error Message', 5000);
                            if (!isPractice) {
                                getLTIQuizMap()
                            }
                    }
                    else
                        NotificationManager.error("Error when getting sections", 'Error Message', 5000);
                }else{
                    if(res.data.data){
                        console.log('res.data.data',res.data.data, isPractice);
                        if (isPractice) {
                            NotificationManager.success("Successfully Mapped the Practice and Performance Assignment", 'Success', 5000);
                            setIsPracticeMapped(true);
                            return
                        }
                        setQuizLink(res.data.data.lti_quiz_Link);
                        setDBSnapShotQuizArr(tempBackArr);
                        
                    }else
                    NotificationManager.error("No data returned from server", 'Error Message', 5000);
                }
            }
          }).catch(err=>{
            NotificationManager.error(err, 'Error Message', 5000);
           
          }).finally(()=>{
            setLoading(false);
          })
    }

    //Events

    const onCourseChange = (_,index) =>{
        setShowSectionSelect(false);
        setQuizLink(undefined);
        setSelectedCourse({...courses[index]})
        getAllSections(courses[index])
        setShowMapButton(false);
    }
    const onSectionChange = (_,index) => {
        console.debug("sections[index]", sections[index])
        setShowMapButton(false);
        setQuizLink(undefined);
        setSelectedSection({...sections[index]})
        getAllQuizes({'course_id':selectedCourse.course_id, 'section_id':sections[index].section_id});
        setIsSubsectionEnable(sections[index].enable_subsection)
        setSelectedQuiz(null)
    }
    
    //single dropdown changes
    const onQuizSelect = (_,index) => {
        
        quizes.map((quiz,i)=>{
            if(i==index){
                quiz.value = true;
            }else{
                quiz.value = false;
            }
            return quiz;
        })
        
        setSelectedQuiz({...quizes[index]})
        setQuizes(quizes)
        setShowMapButton(true);
        setQuizLink(undefined);
    }
 

    const onOptionClick = (optionList) =>{
        let seletedQuizID = []
        optionList.forEach(row => {
        if(row.id !== 'enableAll' && row.id !== 'enableNone'){
            seletedQuizID.push(row);
        }  
        })
        setQuizes(seletedQuizID)
        setShowMapButton(true)
        setQuizLink(undefined);
    }

    const onSelectedBadgeClick = (optionList) => {
        let seletedQuizID = []
        optionList.forEach(row => {
        if(row.id !== 'enableAll' && row.id !== 'enableNone'){
            seletedQuizID.push(row);
        }  
        })
        setQuizes(seletedQuizID)
        setShowMapButton(true)
        setQuizLink(undefined);
    }

    //State Change Handlers
    // useMemo(getLTIQuizMap,[ltiQuizID,ltiSectionID]);    


    //Render
    if(ltiQuizID &&ltiSectionID){
        if(loading){
            return <LoadingSpinner loading></LoadingSpinner>
        }
        //resourceLinkTitle
        let quizTitle = `${resourceLinkTitle?decodeURIComponent(resourceLinkTitle):""}`;
        // let quizLength = []
        // quizes.filter((quiz) => { if(quiz.value === true) { quizLength.push(quiz)} })
            
        return  <SecureShow targetRole={1}>
                    <Grid gutter={1} className='lti-map-container'>
                    
                        <Cell style={{width:"100%"}}>
                            <h2 style={{textAlign:"center"}}>
                                Canvas Assignment to ES Assignment/Test Mapping</h2>
                        </Cell>
                        {
                            quizLink && quizLink.length > 0?
                            <Cell style={{width:"100%"}}><h5>The following assignment has been associated with the Canvas Assignment - <b style={{color:'red',fontSize:'xx-large'}}>{`${resourceLinkTitle?decodeURIComponent(resourceLinkTitle):"'Assignment Name no Found'"}`}</b></h5></Cell>
                            :
                            <Cell style={{width:"100%"}}><h5>Please associate the canvas assignment <b style={{color:'red',fontSize:'xx-large'}}>{quizTitle}</b> with an assignment in Essential Skills </h5></Cell>
                        }

                        
                        <React.Fragment>
                        {
                        !coursesLoading &&

                        <Cell size={6} phoneSize={4} tabletSize={12} id="courseSelectCell">
                            <CardTitle style={{padding:'0px', fontSize:'13px'}}>Course</CardTitle>
                            <SelectField
                                    id="courseSelectCell"
                                    className="gradebook-dropdown"
                                    placeholder="Select Course"
                                    menuItems={courses || []}
                                    itemLabel="label"
                                    itemValue="course_id"
                                    onChange={onCourseChange}
                                    value={selectedCourse?selectedCourse.course_id:0}
                            />
                            {courses === null || courses.length === 0? 
                                <div style={{
                                    color:'red'
                                }}>
                                    You do not have any LTI courses assigned to you in StemFluency. Please ask your admin to give you access to a course and a section
                                </div>
                             : null}
                             
                        </Cell>
                        }
                        
                        {
                            showSectionSelect &&
                        <Cell size={6} phoneSize={4} tabletSize={12} id="sectionsSelectCell">
                            <CardTitle style={{padding:'0px', fontSize:'13px'}}>Section</CardTitle>
                            <SelectField
                                    id="sectionsSelect"
                                    className="gradebook-dropdown"
                                    placeholder="Select Section"
                                    menuItems={sections}
                                    itemLabel="label"
                                    itemValue="section_id"
                                    onChange={onSectionChange}
                                    value={selectedSection?selectedSection.section_id:""}
                            />
                             
                        </Cell>
                     }   

                        {/* Radio Button */}
                        {/* Show this only when course and section is selected */}
                        {selectedCourse?.course_id && selectedSection?.section_id && selectedSection?.enable_practice_and_performance ? 
                        <Cell size={12}>
                            <SelectionControlGroup
                                id="selection-control-group-radios"
                                name="radio-example"
                                type="radio"
                                label=""
                                value={selectedRadio}
                                onChange={(val) => {
                                    if (val === 'assignment') {
                                        setShowQuizSelect(true);
                                    } else {
                                        setShowQuizSelect(false);
                                    }
                                    setSelectedQuiz(null);
                                    setSelectedRadio(val);
                                }}
                                controls={[{
                                label: 'Pick an assignment',
                                value: 'assignment',
                                }, {
                                label: 'Show Practice & Performance for this assignment',
                                value: 'practice',
                                }]}
                            />
                        </Cell>
                        : null}

                        <Cell size={12} phoneSize={4} tabletSize={12} id="quizesSelectCell" >
                            {   quizLoading?
                                 <LoadingSpinner loading></LoadingSpinner>
                                 :
                                showQuizSelect && selectedRadio !== 'practice' ? ( isSubsectionEnable ? 
                                <React.Fragment>
                                <CardTitle style={{padding:'0px', marginBottom:'8px' ,fontSize:'13px'}}>Assignments</CardTitle>
                                <MultiSelectReact
                                 options = {quizes}
                                 optionClicked = {onOptionClick}
                                 selectedBadgeClicked = {onSelectedBadgeClick}
                                 selectedOptionsStyles={selectedOptionsStyles}
                                 optionsListStyles={optionsListStyles}
                                 enableSelectAllNone={true}
                                 />  
                                 </React.Fragment>
                                :
                                <React.Fragment>
                                <CardTitle style={{padding:'0px', marginBottom:'8px' ,fontSize:'13px'}}>Assignments</CardTitle>
                                <SelectField
                                    id="quizesSelect"
                                    className="gradebook-dropdown"
                                    placeholder="Select Assignment"
                                    menuItems={quizes}
                                    itemLabel="label"
                                    itemValue="id"
                                    fullWidth={false}
                                    onChange={onQuizSelect}
                                    value={selectedQuiz?selectedQuiz.id:""}
                                /> </React.Fragment> )
                                :
                                null
                            }
                        </Cell>

                        {selectedRadio === "practice" ? <Cell style={{width:"100%"}}>
                            {/* <h5>Is this a canvas "Practice Assignment"?</h5> */}
                            <Button
                                    id="showMapButton"
                                    raised
                                    primary
                                    onClick={() => {
                                        mapQuiz(true)
                                    }}
                                >SAVE</Button>
                                <div style={{
                                    marginTop:"4px"
                                }}>
                                    {isPracticeMapped ? "Assignment mapped to Performance and Practice" : null}
                                </div>
                        </Cell> : null}

                        <Cell size={3} phoneSize={4} tabletSize={6} id="quizesSelectCell" >
                            {
                                showMapButton && selectedRadio !== "practice" ?
                                <Button
                                    id="showMapButton"
                                    raised
                                    primary
                                    onClick={() => {mapQuiz(false)}}
                                >Map Assignment</Button>:
                                null
                            }
                        </Cell>
                        {selectedRadio !== 'practice' ?
                        <Cell size={12} phoneSize={4} tabletSize={6} id="quizLink" >
                            {
                                quizLink && quizLink.length > 0?
                                <p>Assignment Successfully Mapped</p>:
                                null
                            }
                        </Cell>
                        : null}
                        </React.Fragment>
                        
                        <NotificationContainer />
                    </Grid>
                    
                </SecureShow>
    }
    
    return <p>Invalid Arguments</p>
}


export default LTIQuizPage;

//<a href={quizLink} target='_new'>Preview Quiz</a>